import { setSearchTerm } from "../clientsDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useClientSearch = () => useSearch(s => s.data.listing.clients.searchTerm, setSearchTerm);